export const HEADER_MAP = '/map';
export const HEADER_PERF = '/map/perf';
export const HEADER_SHOPPING_CENTERS = '/shopping-centers';
export const HEADER_INFO = '/info';
export const HEADER_FLOW = '/flow';
export const HEADER_SHOPPERS = '/shoppers';
export const HEADER_MEDIA = '/media';
export const HEADER_GROUP_OVERVIEW = '/group-overview';
export const HEADER_INVESTORS = '/investors';
export const HEADER_MARKETING = '/marketing';
export const HEADER_EVENTS = '/events';
